import React, { createContext, useContext, useState } from 'react';

const NLPLogsContext = createContext();

export const useNLPLogs = () => {
  const context = useContext(NLPLogsContext);
  if (!context) {
    throw new Error('useNLPLogs must be used within NLPLogsProvider');
  }
  return context;
};

export const NLPLogsProvider = ({ children }) => {
  const [nlpLogs, setNLPLogs] = useState([]);

  const addLog = (message, type = 'info', tab = 'general', logId = null) => {
    const log = {
      id: logId || Date.now() + Math.random(),
      message,
      type, // 'info', 'success', 'error', 'loading'
      tab,
      timestamp: new Date()
    };

    setNLPLogs(prev => {
      // If logId is provided, update existing log
      if (logId) {
        const existingIndex = prev.findIndex(l => l.id === logId);
        if (existingIndex !== -1) {
          const updated = [...prev];
          updated[existingIndex] = log;
          return updated;
        }
      }
      // Otherwise add new log
      return [...prev, log].slice(-10); // Keep last 10 logs
    });

    return log.id; // Return ID for updating later
  };

  const removeLog = (logId) => {
    setNLPLogs(prev => prev.filter(log => log.id !== logId));
  };

  const clearLogs = () => {
    setNLPLogs([]);
  };

  const getActiveLogs = () => {
    // Return only logs from last 30 seconds OR loading status
    const now = new Date();
    return nlpLogs.filter(log => {
      const age = (now - log.timestamp) / 1000; // seconds
      return age < 30 || log.type === 'loading';
    });
  };

  return (
    <NLPLogsContext.Provider value={{ nlpLogs, addLog, removeLog, clearLogs, getActiveLogs }}>
      {children}
    </NLPLogsContext.Provider>
  );
};
